/**
 * Shark Bike Core JS
 * Adapted for Shopify
 */

// ==========================================
// CART DRAWER LOGIC
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  const cartTrigger = document.getElementById('cart-drawer-trigger');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartDrawer = document.getElementById('cart-drawer');
  const closeCartBtn = document.getElementById('close-cart');
  
  const shippingText = document.getElementById('shipping-text');
  const shippingProgress = document.getElementById('shipping-progress');

  const SHIPPING_THRESHOLD = 25000000;

  window.openCart = function(e) {
    if(e) e.preventDefault();
    if(cartOverlay) {
      cartOverlay.classList.remove('opacity-0', 'pointer-events-none');
      cartOverlay.classList.add('opacity-100', 'pointer-events-auto');
    }
    if(cartDrawer) {
      cartDrawer.classList.remove('translate-x-full');
      cartDrawer.classList.add('translate-x-0');
    }
    fetchCart();
  }

  window.closeCart = function() {
    if(cartOverlay) {
      cartOverlay.classList.remove('opacity-100', 'pointer-events-auto');
      cartOverlay.classList.add('opacity-0', 'pointer-events-none');
    }
    if(cartDrawer) {
      cartDrawer.classList.remove('translate-x-0');
      cartDrawer.classList.add('translate-x-full');
    }
  }
  
  if(closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  if(cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if(cartTrigger) cartTrigger.addEventListener('click', openCart);

  const formatMoney = (cents) => {
    return '$' + (cents / 100).toLocaleString('es-CO') + ' COP';
  };

  const fetchCart = () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        renderCartItems(cart);
        updateCartUI(cart);
      });
  };

  let stockErrorKey = null;

  const updateCartItem = (key, qty) => {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(res => res.json())
    .then(data => {
      if (data.status === 422) {
        stockErrorKey = key;
        fetchCart();
        return;
      }
      
      const updatedItem = data.items.find(i => i.key === key);
      if (updatedItem && updatedItem.quantity < qty) {
        stockErrorKey = key;
      } else {
        stockErrorKey = null;
      }
      
      renderCartItems(data);
      updateCartUI(data);
    })
    .catch(err => console.error(err));
  };

  window.changeItemQty = function(key, qty) {
    updateCartItem(key, qty);
  };

  const renderCartItems = (cart) => {
    const container = document.getElementById('cart-drawer-items');
    if (!container) return;
    
    if (cart.items.length === 0) {
      container.innerHTML = `
        <div class="flex flex-col items-center justify-center h-full text-center mt-10">
          <svg class="w-16 h-16 text-[#FF6B00]/50 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
          <p class="font-racing text-white tracking-widest text-lg">TU CARRITO ESTÁ VACÍO</p>
        </div>
      `;
      return;
    }

    container.innerHTML = cart.items.map(item => `
      <div class="flex gap-4 items-center bg-white/5 p-4 metallic-border relative group">
        <button onclick="changeItemQty('${item.key}', 0)" class="absolute top-2 right-2 text-[#9CA3AF] hover:text-[#FF6B00] transition-colors z-10" title="Eliminar">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
        </button>
        <div class="bg-black metallic-border flex-shrink-0 flex items-center justify-center overflow-hidden" style="width: 80px; height: 80px; min-width: 80px;">
          <img src="${item.image}" alt="${item.title}" style="width: 100%; height: 100%; object-fit: contain; padding: 4px;">
        </div>
        <div class="flex flex-col flex-1 justify-between h-full gap-2 pr-6">
          <div>
            <h4 class="font-racing text-white tracking-widest text-[14px] leading-tight line-clamp-2">${item.product_title}</h4>
            ${item.variant_title ? `<p class="font-technical text-[#9CA3AF] text-[10px] uppercase">${item.variant_title}</p>` : ''}
            ${stockErrorKey === item.key ? `<p class="font-technical text-red-500 text-[10px] uppercase mt-1 animate-pulse">LÍMITE DE INVENTARIO ALCANZADO</p>` : ''}
          </div>
          <div class="flex items-center justify-between mt-auto">
            <div class="flex items-center gap-4 bg-black metallic-border px-2 py-1 font-technical text-white text-xs">
              <button onclick="changeItemQty('${item.key}', ${item.quantity - 1})" class="text-[#9CA3AF] hover:text-[#FF6B00] transition-colors">-</button>
              <span>${item.quantity}</span>
              <button onclick="changeItemQty('${item.key}', ${item.quantity + 1})" class="text-[#9CA3AF] hover:text-[#FF6B00] transition-colors">+</button>
            </div>
            <span class="font-racing text-white tracking-wider text-sm">${formatMoney(item.final_line_price)}</span>
          </div>
        </div>
      </div>
    `).join('');
  };

  const updateCartUI = (cart) => {
    const subtotalEl = document.getElementById('cart-subtotal');
    if (subtotalEl) {
      subtotalEl.innerText = formatMoney(cart.total_price);
    }
    
    let percentage = (cart.total_price / SHIPPING_THRESHOLD) * 100;
    if(percentage > 100) percentage = 100;
    
    if (shippingProgress) shippingProgress.style.width = percentage + '%';
    
    if(shippingText) {
      if(percentage >= 100) {
        if (shippingProgress) {
          shippingProgress.classList.remove('bg-[#FF6B00]', 'shadow-[0_0_10px_#FF6B00]');
          shippingProgress.classList.add('bg-green-500', 'shadow-[0_0_10px_#22c55e]');
        }
        shippingText.innerHTML = 'ENVÍO NACIONAL GRATUITO DESBLOQUEADO';
        shippingText.classList.remove('text-[#9CA3AF]');
        shippingText.classList.add('text-green-500', 'animate-pulse');
      } else {
        if (shippingProgress) {
          shippingProgress.classList.add('bg-[#FF6B00]', 'shadow-[0_0_10px_#FF6B00]');
          shippingProgress.classList.remove('bg-green-500', 'shadow-[0_0_10px_#22c55e]');
        }
        let remaining = SHIPPING_THRESHOLD - cart.total_price;
        shippingText.innerHTML = `FALTAN ${formatMoney(remaining)} PARA ENVÍO GRATUITO`;
        shippingText.classList.add('text-[#9CA3AF]');
        shippingText.classList.remove('text-green-500', 'animate-pulse');
      }
    }

    // Update cart bubble
    const bubble = document.getElementById('cart-bubble');
    const bubbleCount = document.getElementById('cart-bubble-count');
    if (bubble && bubbleCount) {
      if (cart.item_count > 0) {
        bubble.classList.remove('hidden');
        bubbleCount.innerText = cart.item_count;
      } else {
        bubble.classList.add('hidden');
      }
    }
  };
  
  // Call fetchCart on load
  fetchCart();

  // Bind forms that add to cart
  const cartForms = document.querySelectorAll('form[action="/cart/add"]');
  cartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]') || form.querySelector('button');
      if (btn) {
        const originalText = btn.innerHTML;
        btn.innerHTML = '> PROCESANDO...';
        btn.disabled = true;

        try {
          const formData = new FormData(form);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          
          if (response.ok) {
            btn.innerHTML = '> AÑADIDO';
            setTimeout(() => {
              btn.innerHTML = originalText;
              btn.disabled = false;
            }, 2000);
            fetchCart();
            openCart();
          } else {
            const error = await response.json();
            console.error('Error adding to cart:', error);
            btn.innerHTML = '> ERROR';
            setTimeout(() => {
              btn.innerHTML = originalText;
              btn.disabled = false;
            }, 2000);
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          btn.innerHTML = '> ERROR';
          setTimeout(() => {
            btn.innerHTML = originalText;
            btn.disabled = false;
          }, 2000);
        }
      }
    });
  });
});

// ==========================================
// PREDICTIVE SEARCH TERMINAL LOGIC
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  const searchTrigger = document.getElementById('search-trigger');
  const searchOverlay = document.getElementById('search-overlay');
  const searchModal = document.getElementById('search-modal');
  const closeSearchBtn = document.getElementById('close-search');
  const searchInput = document.getElementById('search-input');

  function openSearchTerminal(e) {
    if(e) e.preventDefault();
    if(searchOverlay) {
      searchOverlay.classList.remove('opacity-0', 'pointer-events-none');
      searchOverlay.classList.add('opacity-100', 'pointer-events-auto');
    }
    if(searchModal) {
      searchModal.classList.remove('-translate-y-10', 'opacity-0');
      searchModal.classList.add('translate-y-0', 'opacity-100');
    }
    setTimeout(() => {
      if(searchInput) searchInput.focus();
    }, 300);
  }

  function closeSearchTerminal(e) {
    if(e) e.preventDefault();
    if(searchOverlay) {
      searchOverlay.classList.remove('opacity-100', 'pointer-events-auto');
      searchOverlay.classList.add('opacity-0', 'pointer-events-none');
    }
    if(searchModal) {
      searchModal.classList.remove('translate-y-0', 'opacity-100');
      searchModal.classList.add('-translate-y-10', 'opacity-0');
    }
  }

  if(searchTrigger) searchTrigger.addEventListener('click', openSearchTerminal);
  if(closeSearchBtn) closeSearchBtn.addEventListener('click', closeSearchTerminal);
  
  if(searchOverlay) {
    searchOverlay.addEventListener('click', (e) => {
      if (e.target === searchOverlay) {
        closeSearchTerminal();
      }
    });
  }

  // PREDICTIVE SEARCH AJAX
  const searchResultsContainer = document.getElementById('predictive-search-results');
  let searchTimeout = null;

  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      const query = searchInput.value.trim();
      if (query.length < 2) {
        if(searchResultsContainer) {
            searchResultsContainer.innerHTML = '';
            searchResultsContainer.classList.add('hidden');
        }
        return;
      }

      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
          .then(res => res.json())
          .then(data => {
            if (!searchResultsContainer) return;
            const products = data.resources.results.products;
            
            if (!products || products.length === 0) {
              searchResultsContainer.innerHTML = `<p class="font-technical text-[#9CA3AF] text-[10px] tracking-widest uppercase mb-2">0 RESULTADOS ENCONTRADOS</p>`;
              searchResultsContainer.classList.remove('hidden');
              return;
            }

            let html = `<p class="font-technical text-[#9CA3AF] text-[10px] tracking-widest uppercase mb-2">${products.length} RESULTADOS ENCONTRADOS</p>`;
            products.forEach(product => {
              html += `
                <a href="${product.url}" class="flex items-center gap-4 bg-[#0a0a0a] border border-[#9CA3AF]/20 p-3 hover:border-[#FF6B00] hover:neon-shadow cursor-pointer group transition-all">
                  ${product.image ? `<img src="${product.image}" alt="${product.title}" class="w-16 h-16 object-contain bg-white/5">` : `<div class="w-16 h-16 bg-white/5 flex items-center justify-center text-[#9CA3AF] text-xs">NO IMG</div>`}
                  <div class="flex flex-col">
                    <span class="font-technical text-white tracking-wider group-hover:text-[#FF6B00] transition-colors">${product.title}</span>
                    <span class="font-racing text-[#FF6B00] tracking-wider mt-1">${product.price}</span>
                  </div>
                </a>
              `;
            });
            searchResultsContainer.innerHTML = html;
            searchResultsContainer.classList.remove('hidden');
          })
          .catch(err => console.error('Error fetching predictive search:', err));
      }, 300);
    });
  }


  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('opacity-100')) {
      closeSearchTerminal();
    }
  });
});

// ==========================================
// PESTAÑAS BENTO GRID
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  const tabBtns = document.querySelectorAll('.tab-btn');
  const productCards = document.querySelectorAll('.product-card');

  if(tabBtns.length > 0 && productCards.length > 0) {
    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        // Eliminar estado activo de todos los botones
        tabBtns.forEach(b => {
          b.classList.remove('border-[#FF6B00]', 'text-white', 'neon-shadow');
          b.classList.add('border-transparent', 'text-gray-400');
        });
        
        // Activar el botón clickeado
        btn.classList.remove('border-transparent', 'text-gray-400');
        btn.classList.add('border-[#FF6B00]', 'text-white', 'neon-shadow');

        const targetCategory = btn.getAttribute('data-category-target');

        // PASO 1: Ocultar todo
        productCards.forEach(card => card.classList.add('hidden'));
        
        // PASO 2: Pequeño delay para reiniciar animación
        setTimeout(() => {
          productCards.forEach(card => card.classList.add('animate-fade-up-elite'));
        }, 10);
        
        // Quitar clase de animacion antes
        productCards.forEach(card => {
          card.classList.remove('animate-fade-up-elite');
        });
        
        const visibleCards = Array.from(productCards).filter(card => 
          card.getAttribute('data-category') === targetCategory
        );
        visibleCards.forEach(card => card.classList.remove('hidden'));
      });
    });
    
    // Initial setup
    productCards.forEach(card => card.classList.add('hidden'));
    const initialCards = Array.from(productCards).filter(card => 
      card.getAttribute('data-category') === 'piloto'
    );
    initialCards.forEach(card => card.classList.remove('hidden'));
  }
});

// ==========================================
// CONTACT TERMINAL DROPDOWN
// ==========================================
let contactMenuOpen = false;

window.toggleContactMenu = function() {
  const terminal = document.getElementById('contact-terminal');
  const chevron  = document.getElementById('contact-chevron');
  if (!terminal) return;

  if (contactMenuOpen) {
    closeContactMenu();
  } else {
    // Abrir
    terminal.classList.remove('opacity-0', 'pointer-events-none');
    terminal.style.animation = 'terminalOpen 0.3s ease forwards';
    if(chevron) chevron.style.transform  = 'rotate(180deg)';
    contactMenuOpen = true;
  }
};

window.closeContactMenu = function() {
  if (!contactMenuOpen) return;
  const terminal = document.getElementById('contact-terminal');
  const chevron  = document.getElementById('contact-chevron');
  if (!terminal) return;
  
  terminal.classList.add('opacity-0', 'pointer-events-none');
  terminal.style.animation = 'none';
  if(chevron) chevron.style.transform  = 'rotate(0deg)';
  contactMenuOpen = false;
};

document.addEventListener('click', (e) => {
  const wrapper = document.getElementById('contact-dropdown-wrapper');
  if (contactMenuOpen && wrapper && !wrapper.contains(e.target)) {
    closeContactMenu();
  }
});

// Dropdown "Tienda" menu
let tiendaMenuOpen = false;
window.toggleTiendaMenu = function() {
  const menu = document.getElementById('tienda-dropdown');
  const chevron = document.getElementById('tienda-chevron');
  if(!menu) return;
  if(tiendaMenuOpen) {
    menu.classList.add('opacity-0', 'pointer-events-none');
    if(chevron) chevron.style.transform = 'rotate(0deg)';
    tiendaMenuOpen = false;
  } else {
    menu.classList.remove('opacity-0', 'pointer-events-none');
    if(chevron) chevron.style.transform = 'rotate(180deg)';
    tiendaMenuOpen = true;
  }
};
document.addEventListener('click', (e) => {
  const wrapper = document.getElementById('tienda-dropdown-wrapper');
  if (tiendaMenuOpen && wrapper && !wrapper.contains(e.target)) {
    toggleTiendaMenu();
  }
});

// ==========================================
// TECH HANDOVER LOGIC (WHATSAPP HUD)
// ==========================================
window.triggerTechHandover = function(e, url) {
  e.preventDefault();
  const overlay = document.getElementById('tech-handover-overlay');
  if (!overlay) {
    window.open(url, '_blank');
    return;
  }
  overlay.classList.remove('opacity-0', 'pointer-events-none');
  overlay.classList.add('opacity-100');

  setTimeout(() => {
    window.open(url, '_blank');
    // Hide overlay right after redirect triggers
    setTimeout(() => {
      overlay.classList.remove('opacity-100');
      overlay.classList.add('opacity-0', 'pointer-events-none');
    }, 300);
  }, 800);
};
